/** File is auto-generated by TypeWriter, a plug-in for Visual Studio. Modifications will be overridden when the template is rendered */
import { ObjectUtil } from "src/utils";
import moment from "moment";


interface TimeIntervalDTO {
  start: moment.Moment | null;
  end: moment.Moment | null;
}
const TimeIntervalDTO = {
  create: (initValues?: Partial<TimeIntervalDTO> | null): TimeIntervalDTO => {
    const defaults: TimeIntervalDTO = {
      start: null,
      end: null,
    };
    const fixedValues: Partial<TimeIntervalDTO> = initValues != null
      ? {
        start: initValues.start != null ? ObjectUtil.ToMoment(initValues.start) : null,
        end: initValues.end != null ? ObjectUtil.ToMoment(initValues.end) : null,
      }
      : {};
    return { ...defaults, ...initValues, ...fixedValues };
  }
};

export default TimeIntervalDTO;
